import { render, staticRenderFns } from "./RecipeDescription.vue?vue&type=template&id=0b232522&scoped=true"
import script from "./RecipeDescription.vue?vue&type=script&lang=js"
export * from "./RecipeDescription.vue?vue&type=script&lang=js"
import style0 from "./RecipeDescription.vue?vue&type=style&index=0&id=0b232522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b232522",
  null
  
)

export default component.exports